import { GameScore, initGameScoreState } from 'common/stores/GameScore';
import { useUserSession } from 'common/stores/UserSessionStore';
import { matchProject } from 'common/helpers/GameHelper';
import HttpService from 'common/services/HttpService';
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';


export function GameScoreComponent({ children }) {
    const { getLeapAccount } = useUserSession();
    const [state, setState] = useState(initGameScoreState);
    const { projectId } = useParams() || {};

    useEffect(() => {
        fetchGameScore();
    }, [projectId]);

    async function fetchGameScore() {
        const { uid } = getLeapAccount();

        if(!projectId) {
            return;
        };

        const { gameId } = matchProject(projectId);

        try {
            const gameScore = await HttpService.fetchUserScore({ gameId, userId: uid })

            return setState(prev =>({
                ...prev,
                [projectId]: gameScore
            }));
        } catch (error) {
            console.log(error);
        };
    };

    async function setGameScore(body) {
        const { uid } = getLeapAccount();
        const { gameId } = matchProject(projectId);

        try {
            const gameScore = await HttpService.setUserScore({
                gameId,
                ...body,
                userId: uid
            })

            return setState(prev =>({
                ...prev,
                [projectId]: gameScore
            }));
        } catch (error) {
            console.log(error);
        };
    };

    async function setGameBattles(body) {
        const { uid } = getLeapAccount();
        const { gameId } = matchProject(projectId);

        try {
            const gameBattles = await HttpService.setUserBattles({
                gameId,
                ...body,
                userId: uid
            })

            return setState(gameBattles);
        } catch (error) {
            console.log(error);
        };
    };

    function findMusic({ projectId, slug }) {
        const { musics = [] } = state[projectId] || {};

        return musics.find(({ music_id: id }) => id === slug) || {};
    };

    function findInstrument({ projectId, musicSlug, slug: instrumentSlug }) {
        const { instruments = [] } = findMusic({ projectId, slug: musicSlug });

        return instruments.find(({ instrument_id: id }) => id === instrumentSlug) || {};
    };

    return (
        <GameScore.Provider value={{
            gameState: state[projectId] || initGameScoreState?.default || {},
            fetchGameScore,
            findInstrument,
            findMusic,
            setGameScore,
            setGameBattles
        }}>
            {children}
        </GameScore.Provider>
    );
};